import React from 'react';
import './AboutSection.css';

// Hook פשוט לזיהוי כניסה לסקשן
function useSectionInView() {
  const [visible, setVisible] = React.useState(false);
  const ref = React.useRef(null);

  React.useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return [ref, visible];
}

// סמלילים עולים מלמטה למעלה
function FloatingIcons() {
  const icons = [
    { src: '/home/סמלילים-01.png', delay: 0, x: '8%', duration: 10, size: 70, rotate: 1 },
    { src: '/home/סמלילים-02.png', delay: 1.2, x: '18%', duration: 11, size: 55, rotate: -1 },
    { src: '/home/סמלילים-03.png', delay: 2.4, x: '28%', duration: 9, size: 80, rotate: 1 },
    { src: '/home/סמלילים-01.png', delay: 3.6, x: '38%', duration: 10.5, size: 65, rotate: -1 },
    { src: '/home/סמלילים-02.png', delay: 4.8, x: '48%', duration: 11.5, size: 75, rotate: 1 },
    { src: '/home/סמלילים-03.png', delay: 0.6, x: '58%', duration: 9.5, size: 60, rotate: -1 },
    { src: '/home/סמלילים-01.png', delay: 1.8, x: '68%', duration: 10.2, size: 85, rotate: 1 },
    { src: '/home/סמלילים-02.png', delay: 3, x: '78%', duration: 11.2, size: 70, rotate: -1 },
    { src: '/home/סמלילים-03.png', delay: 4.2, x: '88%', duration: 9.8, size: 65, rotate: 1 },
    { src: '/home/סמלילים-01.png', delay: 5.4, x: '13%', duration: 10.8, size: 75, rotate: -1 },
    { src: '/home/סמלילים-02.png', delay: 0.3, x: '23%', duration: 11.8, size: 80, rotate: 1 },
    { src: '/home/סמלילים-03.png', delay: 1.5, x: '33%', duration: 9.3, size: 55, rotate: -1 },
    { src: '/home/סמלילים-01.png', delay: 2.7, x: '43%', duration: 10.3, size: 70, rotate: 1 },
    { src: '/home/סמלילים-02.png', delay: 3.9, x: '53%', duration: 11.3, size: 85, rotate: -1 },
    { src: '/home/סמלילים-03.png', delay: 5.1, x: '63%', duration: 9.7, size: 60, rotate: 1 },
    { src: '/home/סמלילים-01.png', delay: 0.9, x: '73%', duration: 10.7, size: 75, rotate: -1 },
    { src: '/home/סמלילים-02.png', delay: 2.1, x: '83%', duration: 11.7, size: 65, rotate: 1 },
    { src: '/home/סמלילים-03.png', delay: 3.3, x: '93%', duration: 9.2, size: 80, rotate: -1 },
  ];

  return (
    <div className="floating-icons-container">
      {icons.map((icon, i) => (
        <img
          key={i}
          src={icon.src}
          alt=""
          className={`floating-icon ${icon.rotate === 1 ? 'rotate-right' : 'rotate-left'}`}
          style={{
            left: icon.x,
            width: `${icon.size}px`,
            animationDelay: `-${icon.delay}s`,
            animationDuration: `${icon.duration}s`,
          }}
        />
      ))}
    </div>
  );
}

export default function AboutSection() {
  const [ref, visible] = useSectionInView();

  return (
    <section ref={ref} className={`about-section ${visible ? 'visible' : ''}`}>
      <FloatingIcons />
      
      <div className="about-content">
        <div className="about-text-box">
          <div className="about-logo-box">
            <img src="/home/לוגו עדכני-02.jpg" alt="הלוגו" />
          </div>

          <div className="about-text-content">
            <div className="about-greeting">
              <span className="about-hi">היי, שלום! </span>
              <span className="about-small">(חיוך מנומס)</span>
            </div>
            
            <div className="about-brand">כזאתי מן תוכנית</div>
            
            <div className="about-intro">נעים להכיר וכיף לפגוש :)</div>
            
            <div className="about-title">מה זה כזאתי מן תוכנית?</div>
            
            <ul className="about-list">
              <li>אתר תכניות, כיפי ושימושי</li>
              <li>לתוכניות שוות ומוכנות להפעלה עצמית.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}